import $axios from '@/api/apiPublic';

const requestFeeback = async data => {
  const response = await $axios.post('feedback', data);
  return response;
};

export default {
  requestFeeback,
};
